import styled, { css } from 'styled-components';

import OnOffSwitch from 'app/shared/components/OnOffSwitch';

import {
    Anchor,
    Text,
    token,
} from '@zillow/constellation';

import {
    Row,
    ContentBox,
} from '@zillow/zrs-comet';

export const StyledRow = styled(Row)`
    background-color: ${token('colors.white')};
`;

export const StyledAnchor = styled(Anchor)`
    color: #0055CC;
    font-weight: bold;
`;

export const StyledText = styled(Text)`
    font-weight: 600;
    text-align: center;

    ${props => props.theme.ns().media.lg(
        css`
        text-align: left;
        `
    )};
`;

export const StyledOnOffSwitch = styled(OnOffSwitch)`
    text-align: center;

    ${props => props.theme.ns().media.lg(
        css`
        text-align: left;
        `
    )};
`;

export const StyledContentBox = styled(ContentBox)`
    text-align: center;
`;
